import { css } from 'linaria'
import fontSizes from '../../../styles/fontSizes'
import theme, {
  COLORS,
  fontWeights,
} from '../../../styles/theme'

const classes = {
  calendarWrapper: css`
    position: relative;
    min-height: ${theme.spacing(13.5)}px;
    margin-bottom: ${theme.spacing(12.5)}px;
    div[class*='messageWrapper'] {
      margin-top: ${theme.spacing(3.75)}px;
      max-width: 86%;
      ${theme.breakpoints.down('sm')} {
        max-width: 100%;
      }
    }
    div[class*='spinner'] {
      position: relative;
      width: ${theme.spacing(7.5)}px;
      height: ${theme.spacing(7.5)}px;
      display: block;
      margin: 0 auto;
      margin-top: ${theme.spacing(11.25)}px;
      div {
        width: ${theme.spacing(7.5)}px;
        height: ${theme.spacing(7.5)}px;
      }
    }
  `,

  weekDaysWrapper: css`
    .MuiTypography-root {
      text-align: center;
      font-size: ${fontSizes.body1};
      font-style: normal;
      font-weight: ${theme.typography.fontWeightRegular!};
      line-height: ${theme.spacing(3.37)}px;
      color: ${COLORS.bodyTextPrimary};

      ${theme.breakpoints.down('md')} {
        font-size: ${fontSizes.body3};
      }
    }
  `,

  weekDay: css`
    position: relative;
    padding: ${theme.spacing(2)}px 0;
    width: ${theme.spacing(13.75)}px;
    border: 1px solid ${COLORS.gray2};
    border-radius: 0;
    margin-top: ${theme.spacing(1.5)}px;
    background-color: ${COLORS.white};

    ${theme.breakpoints.down('md')} {
      width: ${theme.spacing(10.12)}px;
    }
    ${theme.breakpoints.down('xs')} {
      width: ${theme.spacing(6.12)}px;
    }
    ${theme.breakpoints.down(374)} {
      width: ${theme.spacing(5.5)}px;
    }

    &:hover:enabled {
      background-color: ${COLORS.gray1};
      cursor: pointer;
    }

    .MuiTypography-root {
      font-weight: ${theme.typography.fontWeightMedium!};
    }

    &.preselected {
      border: 1px solid ${COLORS.secondary};
    }

    &.selected {
      border: 1px solid ${COLORS.secondary};
      background-color: ${COLORS.secondaryLight2};
      &:hover {
        background-color: ${COLORS.secondaryLight2};
      }
    }

    &.first {
      border-radius: ${theme.spacing(2.5)}px 0 0 ${theme.spacing(2.5)}px;
    }

    &.last {
      border-radius: 0 ${theme.spacing(2.5)}px ${theme.spacing(2.5)}px 0;
    }

    &.disabled {
      .MuiTypography-root {
        color: ${COLORS.gray3} !important;
      }
    }

    &.currentDate:after {
      content: '';
      background-color: ${COLORS.primary};
      border-radius: 50%;
      height: ${theme.spacing(0.5)}px;
      left: 50%;
      position: absolute;
      top: 70%;
      transform: translateX(-50%);
      width: ${theme.spacing(0.5)}px;
    }

    .MuiTypography-root {
      ${theme.breakpoints.down('md')} {
        font-size: ${fontSizes.body1};
      }
    }
  `,

  dateRange: css`
    min-width: ${theme.spacing(27)}px;
    border: none;
    ${theme.breakpoints.down('md')} {
      margin-bottom: -${theme.spacing(6)}px;
    }
    ${theme.breakpoints.down('sm')} {
      min-width: ${theme.spacing(26)}px;
    }
  `,

  slotsWrapper: css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -${theme.spacing(6.25)}px;

    .MuiTypography-body1 {
      color: ${COLORS.primary};
      font-size: ${fontSizes.h4};
      font-weight: ${fontWeights.semibold};
      text-align: center;
    }
  `,

  timeslot: css`
    white-space: nowrap;
    text-align: center;
    padding: ${theme.spacing(2)}px;
    width: ${theme.spacing(25)}px;
    border-radius: ${theme.spacing(2.5)}px;
    border: 1px solid ${COLORS.gray2};
    background-color: ${COLORS.white};

    ${theme.breakpoints.down('md')} {
      width: ${theme.spacing(22.12)}px;
    }
    ${theme.breakpoints.down('sm')} {
      width: ${theme.spacing(20.37)}px;
    }
    ${theme.breakpoints.down('xs')} {
      width: ${theme.spacing(19.12)}px;
    }

    &:hover:enabled {
      background-color: ${COLORS.gray1};
      cursor: pointer;
    }

    &.selected {
      border: 1px solid ${COLORS.secondary};
      background-color: ${COLORS.secondaryLight2};
      &:hover {
        background-color: ${COLORS.secondaryLight2};
      }
    }

    &:disabled {
      .MuiTypography-root {
        color: ${COLORS.gray3} !important;
      }
    }

    .MuiTypography-root {
      text-align: center;
      font-size: ${fontSizes.body1};
      font-style: normal;
      font-weight: ${fontWeights.semibold};
      line-height: ${theme.spacing(3.375)}px;
    }
  `,

  arrowButton: css`
    &.MuiButtonBase-root {
      background: ${COLORS.white};
      height: ${theme.spacing(6)}px;
      position: absolute;
      top: ${theme.spacing(24.5)}px;
      border: none;
      width: ${theme.spacing(6)}px;
      .MuiSvgIcon-root {
        font-size: ${fontSizes.h4};
      }
    }
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }
  `,
}

export default classes
